
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/retail-investor/topics-cocotora",
      function () {
        return require("private-next-pages/retail-investor/topics-cocotora.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/retail-investor/topics-cocotora"])
      });
    }
  